<template>
  <div id="sistem-pengawasan">

    <banner
      title="Sistem Pengaduan"
      description="Laporkan masalah terkait buku pelajaran Kemendikbud disini. Setiap laporan sangat berguna untuk meningkatkan kualitas buku Pelajaran Sekolah"
      :breadcrumbs="breadcrumbs"
      :icon="require('@/assets/sistem-pengawasan/decoration/Vector.svg')"
    />

    <section id="content" class="mt-4 px-3 px-lg-5">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <img src="@/assets/sistem-pengawasan/apa-itu-sistem-pengawasan.png" class="w-100" alt="Image">
        </div>
        <div class="col-lg-6">
          <h1 class="text-primary font-weight-bold mt-5">Apa itu sistem pengaduan</h1>
          <p class="lead">Sistem Pengaduan Buku memungkinkan guru, siswa, dan masyarakat menginformasikan masalah terkait buku pelajaran, seperti kualitas cetak, salah cetak, harga eceran (HET), distribusi, konten, bahasa, dan legalitas. Setiap laporan akan diterima, diverifikasi, dan ditindaklanjuti oleh tim yang berwenang. Kami menjaga kerahasiaan identitas pelapor; harap sertakan informasi dan bukti yang cukup agar tindak lanjut dapat dilakukan lebih cepat.</p>
        </div>
      </div>
    </section>

    <section id="content" class="mt-10 px-3 px-lg-5">
      <div class="text-center">
        <h1 class="text-primary font-weight-bold mb-3">Bagaimana Cara Melaporkan Kendala?</h1>
        <p class="lead text-muted">Langkah-langkah untuk melaporkan kendala terkait buku</p>
      </div>
      <div class="timeline align-items-center align-items-lg-stretch">
        <div class="timeline-step active">
            <div class="step-number">1</div>
            <div class="step-content">
                <h3>Tulis Laporan</h3>
                <p>Tuliskan rincian keluhan Anda</p>
            </div>
        </div>
        <div class="timeline-step">
            <div class="step-number">2</div>
            <div class="step-content">
                <h3>Proses Verifikasi</h3>
                <p>Laporan Anda akan diproses oleh pihak berwenang</p>
            </div>
        </div>
        <div class="timeline-step">
            <div class="step-number">3</div>
            <div class="step-content">
                <h3>Proses Tindak Lanjut</h3>
                <p>Laporan Anda ditindaklanjuti dan dikembalikan</p>
            </div>
        </div>
        <div class="timeline-step">
            <div class="step-number">4</div>
            <div class="step-content">
                <h3>Beri Tanggapan</h3>
                <p>Anda dapat memberi tanggapan tentang Laporan yang dikembalikan</p>
            </div>
        </div>
        <div class="timeline-step">
            <div class="step-number">5</div>
            <div class="step-content">
                <h3>Selesai</h3>
                <p>Laporan akan ditindaklanjuti hingga selesai</p>
            </div>
        </div>
      </div>
    </section>

    <section id="content" class="mt-10 px-3 px-lg-5">
      <div class="row">
        <div class="col-lg-6">
          <h1 class="text-primary font-weight-bold mt-5">Apa Saja Jenis Pengaduan</h1>
          <p class="lead text-muted">Langkah-langkah untuk melaporkan kendala terkait buku</p>
          <div class="row mt-5">
            <div class="col-4 mb-3">
              <h6 class="px-3 py-3 bg-primary-50 text-center rounded">Kualitas Cetak</h6>
            </div>
            <div class="col-4 mb-3">
              <h6 class="px-3 py-3 bg-primary-50 text-center rounded">Distribusi</h6>
            </div>
            <div class="col-4 mb-3">
              <h6 class="px-3 py-3 bg-primary-50 text-center rounded">(HET)</h6>
            </div>
            <div class="col-4 mb-3">
              <h6 class="px-3 py-3 bg-primary-50 text-center rounded">Pengadaan</h6>
            </div>
            <div class="col-4 mb-3">
              <h6 class="px-3 py-3 bg-primary-50 text-center rounded">Salah Cetak</h6>
            </div>
            <div class="col-4 mb-3">
              <h6 class="px-3 py-3 bg-primary-50 text-center rounded">Bahasa</h6>
            </div>
            <div class="col-4 mb-3">
              <h6 class="px-3 py-3 bg-primary-50 text-center rounded">Kualitas Konten</h6>
            </div>
            <div class="col-4 mb-3">
              <h6 class="px-3 py-3 bg-primary-50 text-center rounded">Kualitas Konten</h6>
            </div>
            <div class="col-4 mb-3">
              <h6 class="px-3 py-3 bg-primary-50 text-center rounded">Kesesuaian Kurikulum</h6>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <img src="@/assets/sistem-pengawasan/jenis-pengaduan.png" class="w-100" alt="Image">
        </div>
      </div>
    </section>

    <section id="content" class="mt-10 px-3 px-lg-5">
      <div class="text-center">
        <h1 class="text-primary font-weight-bold mb-3">Monitoring Riwayat Laporan</h1>
        <p class="lead text-muted">Pantau riwayat laporan lebih mudah melalui menu profil</p>
        <img src="@/assets/sistem-pengawasan/monitoring.png" class="w-100 mt-5" alt="">
      </div>
    </section>

    <CTA/>

  </div>
</template>
<style scoped>
.sidebar {
  border: 1px solid #dbddf0;
  border-radius: 0.5rem;
  padding: 1rem;
}
</style>
<script>
// import { mapActions, mapState } from "vuex";
import Banner from "../../components/homepage/Banner.vue";
import CTA from "../../components/sistem-pengawasan/CTA.vue";
export default {
  components: { Banner, CTA },
  watch: {
    filter() {
      this.pageNumber = 1;
    },
  },
  data() {
    return {
      breadcrumbs: [
        {
          label: "Beranda",
          url: "/",
        },
        {
          label: "Sistem Pengaduan",
          url: "",
        },
      ],
    };
  },
};
</script>
